export const getByNormalizedKey = <T>(
  obj: Record<string, T>,
  key?: string,
): T | undefined => {
  if (!key) {
    return undefined;
  }

  if (obj[key] !== undefined) {
    return obj[key];
  }

  const normalized = key.toLowerCase();

  if (obj[normalized] !== undefined) {
    return obj[normalized];
  }

  const matchedKey = Object.keys(obj).find(
    (k) => k.toLowerCase() === normalized,
  );

  return matchedKey ? obj[matchedKey] : undefined;
};